import {IStoreState} from "../types";

export const getContactUs = ({contact_us}: IStoreState) => contact_us;
export const isDataRequestedContactUs = ({contact_us}: IStoreState) =>
	contact_us.is_data_requested;
export const isDataContactUsSended = ({contact_us}: IStoreState) =>
	contact_us.is_success;
